module.exports = __webpack_public_path__ + "img/primary-bar-chart-icon.a6de26fc.svg";